import { render, staticRenderFns } from "./AppIntegration.vue?vue&type=template&id=256fc54d&scoped=true"
import script from "./AppIntegration.vue?vue&type=script&lang=js"
export * from "./AppIntegration.vue?vue&type=script&lang=js"
import style0 from "./AppIntegration.vue?vue&type=style&index=0&id=256fc54d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256fc54d",
  null
  
)

export default component.exports